<template>
  <List
    v-if="props.specs"
    striped>
    <ListItem
      v-for="(item, index) in props.specs.values"
      :key="index">
      {{ item }}
    </ListItem>
  </List>
</template>
<script setup>
const props = defineProps({
  specs: {
    type: [Object, Array, Boolean],
    default: null
  }
})
</script>
